import * as React from 'react';
import Link from 'next/link';

import cx from 'classnames';
import { CanvasAnimatedTile } from 'themes/canvas/components/CanvasAnimatedTile';
import { Marquee } from 'themes/canvas/components/Marquee/Marquee';

import { Heading } from 'components/Heading';

import { useServicesPage } from 'hooks/page/services/useServicesPage';

import { PackageItem } from 'routes/packages/types';

import { Package } from './Package/Package';

import s from './CanvasPackages.module.css';

type CanvasPackagesProps = {
  packageList: PackageItem[];
};

const CanvasPackages = ({ packageList }: CanvasPackagesProps) => {
  const { renderBookingHeader } = useServicesPage();

  const items = packageList.map((packageItem) => packageItem.name);

  return (
    <>
      {renderBookingHeader()}
      <main>
        <section className={cx(s.root, s.listView)}>
          <Heading as="h2" variant="large" className={s.servicesHeading}>
            Packages
          </Heading>
          <p className={s.description}>
            <b>Already have a package?</b> Book as usual on our{' '}
            <Link href="/services">Services page</Link> — your credits will
            apply automatically at checkout.
            <br /> Coming soon, you&apos;ll be able to purchase your packages
            directly from this website.
          </p>
          <div className={s.list}>
            <div className={s.servicesContainer}>
              {packageList.map((packageItem) => (
                <React.Fragment key={packageItem.token}>
                  <CanvasAnimatedTile threshold={0}>
                    <span className={s.tile}>
                      <Package package={packageItem} />
                    </span>
                  </CanvasAnimatedTile>
                </React.Fragment>
              ))}
            </div>
          </div>
        </section>
      </main>
      <section className={s.marquee}>
        <Marquee items={items} />
      </section>
    </>
  );
};

export { CanvasPackages };
